import React, { useState } from 'react';
import { ArrowLeft, Info, TrendingUp } from 'lucide-react';

import { formatCurrencyAmount, getInstallmentDescriptionFromKey } from '../../../../../../utils/miscFunctions';
import Button from '../../../../../../components/form-control/Button';
import { FormData, QuoteResponse } from './Calculator';
import { useSelector } from 'react-redux';
import { getQuoteWidgetPayloadFromState } from '../../../../../../states/slices/quoteWidgetSlice';
import PremiumDetailsStep from '../../../../../shared/policies/auto/create-policy/components/PremiumDetailsStep';
import { PremiumDetails } from '../../../../../shared/policies/auto/create-policy';
import { useNavigate, useSearchParams } from 'react-router-dom';
import useRoute from '../../../../../../hooks/routesHook';


interface QuoteResponseStepProps {
  data: QuoteResponse | PremiumDetails | null;
  formData?: FormData;
  onPrevious?: () => void;
  onclose: ()=> void;
}

const QuoteResponseStep: React.FC<QuoteResponseStepProps> = ({ data, formData, onPrevious, onclose }) => {
  const navigate = useNavigate();
  const { getDashboardBase } = useRoute();

  return (
    <>
    
     <PremiumDetailsStep
        data={data as PremiumDetails}
        vehicleData={undefined}
        policyData={undefined}
        onUpdate={(data: any) => {}}
        onNext={()=> {
          onclose();
          const canReload = window.location.pathname.includes('dynamic-create-policy') && window.location.search.includes('type=motor');
          if(canReload)
            window.location.reload();
          navigate(`${getDashboardBase()}/policies/dynamic-create-policy?type=motor`);
         
        }}
        isFleet={false}
        onPrevious={()=>onPrevious?.()}
      />
  
    </>
  );
};

export default QuoteResponseStep;
